<template>
  <div class="cell-row">
    <div class="row-wrap">
      <div
        class="cell-label"
        :class="[labelFixTop ? 'top-label' : '']"
        :style="{ width: labelWidth + 'px' }"
      >
        {{ label }}
      </div>
      <div v-if="showValue" class="cell-value">
        <slot />
      </div>
      <div class="cell-action">
        <slot name="action" />
      </div>
    </div>
    <div v-if="showLine" class="underline"></div>
  </div>
</template>

<script>
export default {
  name: "CellRow",
  props: {
    label: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: Number,
      default: 70,
    },
    showValue: {
      type: Boolean,
      default: true,
    },
    action: {
      type: Boolean,
      default: false,
    },
    labelFixTop: {
      type: Boolean,
      default: false,
    },
    showLine: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.row-wrap ::v-deep {
  display: flex;
  align-items: center;
  padding: 24px 30px;
  .cell-label {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    &.top-label {
      align-self: flex-start;
    }
  }
  .cell-value {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    margin-right: 20px;
  }
  .cell-action {
  }
  .el-button {
    padding: 0;
    border: none;
  }
}
.underline {
  height: 1px;
  background-color: #f2f2f2;
}
</style>
